import { TFunction } from "i18next";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import BriaFaqSection from "../../../common/BriaFaqSection/BriaFaqSection";
import { FaqItem } from "../../../common/BriaFaqSection/faq";

// Convert Figma FAQ format to common FAQ format
function getFigmaFaqs(t: TFunction): FaqItem[] {
	return [
		{
			question: t("faq1.question"),
			answer: [{ type: "text", content: t("faq1.answer") }],
		},
		{
			question: t("faq2.question"),
			answer: [{ type: "text", content: t("faq2.answer") }],
		},
		{
			question: t("faq3.question"),
			answer: [{ type: "text", content: t("faq3.answer") }],
		},
		{
			question: t("faq4.question"),
			answer: [{ type: "text", content: t("faq4.answer") }],
		}
	];
}

const handleAnswerLinkClick = (event: React.MouseEvent<HTMLElement>) => {
	const target = event.target as HTMLElement;
	if (target.tagName === "A") {
		event.preventDefault();
		const href = target.getAttribute("href");
		if (href) {
			window.open(href, "_blank");
		}
	}
};

const FigmaFaqSection: React.FC = () => {
	const { t } = useTranslation("translation", { keyPrefix: "figma.faqSection" });
	const { t: tFaqs } = useTranslation("translation", { keyPrefix: "figma.faqSection.faqs" });

	const faqItems = getFigmaFaqs(tFaqs);

	return (
		<BriaFaqSection
			title={t("title")}
			faqItems={faqItems}
			onAnswerClick={handleAnswerLinkClick}
		/>
	);
};

export default observer(FigmaFaqSection); 